module.exports = __webpack_public_path__ + "img/success.ca351b25.png";